export type IoViewMode = 'boldsign' | 'docusign';

const STORAGE_KEY = 'billing.insertion-orders.view';

export function readIoViewMode(): IoViewMode {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (value === 'boldsign' || value === 'docusign') {
      return value;
    }
  } catch {
    // Ignore storage access errors (private mode, blocked storage).
  }
  return 'boldsign';
}

export function writeIoViewMode(mode: IoViewMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Ignore storage access errors (private mode, blocked storage).
  }
}
